module.exports = __webpack_public_path__ + "static/media/achievement-day-dreamer.5c48fba1.svg";